<template>
  <v-app-bar
    id="app-bar"
    flat
    :border="true"
    class="px-sm-2"
  >
    <template #prepend>
      <v-app-bar-nav-icon
        v-if="isLayoutVertical"
        class="me-2"
        @click.stop="drawer = !drawer"
      />
      <div class="d-flex align-center ms-sm-6 ms-6 me-4 me-md-8">
        <v-app-bar-title class="d-none d-sm-block">
          <router-link :to="{ name: '/' }">
            <v-img
              :src="brand.logo"
              width="150"
            />
          </router-link>
        </v-app-bar-title>
      </div>
    </template>

    <v-spacer />
    <div class="d-flex me-md-8 me-lg-8 me-sm-1">
      <AppBarTabs />
    </div>
  </v-app-bar>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { useDisplay } from 'vuetify'

  import { brand } from '@/config/brand'

  import AppBarTabs from './AppBarTabs.vue'

  const drawer = defineModel<boolean>('drawer', {
    type: Boolean,
    default: false
  })

  const { smAndDown } = useDisplay()
  const isLayoutVertical = computed(() => smAndDown.value)
</script>
